/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Shared_BannerInputs */

const es_chat_shared_banner = /** @type {(inputs: Chat_Shared_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estás viendo un chat compartido. Esta conversación es de solo lectura.`)
};

const en_chat_shared_banner = /** @type {(inputs: Chat_Shared_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are viewing a shared chat. This conversation is read-only.`)
};

/**
* | output |
* | --- |
* | "You are viewing a shared chat. This conversation is read-only." |
*
* @param {Chat_Shared_BannerInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_shared_banner = /** @type {((inputs?: Chat_Shared_BannerInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Shared_BannerInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_shared_banner(inputs)
	return en_chat_shared_banner(inputs)
});
export { chat_shared_banner as "chat.shared.banner" }